export type EventProps = {
  action: string;
  allowCustomScripts?: boolean;
  callback?(): void;
  category?: string;
  label?: string;
  nonInteraction?: boolean;
  sendTo?: string | string[];
  transport?: "beacon";
  value?: number;
};

const isAnalyticsEnabled = () => typeof window?.gtag !== "undefined";

export function trackCustomEvent({
  action,
  allowCustomScripts,
  callback,
  category,
  label,
  nonInteraction,
  sendTo,
  transport,
  value,
}: EventProps) {
  if (isAnalyticsEnabled()) {
    window.gtag("event", action, {
      allow_custom_scripts: allowCustomScripts,
      event_callback: callback,
      event_category: category,
      event_label: label,
      non_interaction: nonInteraction,
      send_to: sendTo,
      transport_type: transport,
      value,
    });
  } else {
    callback?.();
  }
}

export function trackCustomException(description: string, fatal?: boolean) {
  if (isAnalyticsEnabled()) {
    window.gtag("event", "exception", {
      description,
      fatal,
    });
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function trackCustomDimensions(dimensions: Record<string, any>) {
  if (isAnalyticsEnabled()) {
    window.gtag("set", dimensions);
  }
}
